/** https://reactrouter.com/en/main/start/faq#what-happened-to-withrouter-i-need-it */

import React from 'react';
import {
  useNavigate,
  useLocation,
  useParams,
  NavigateFunction,
  Location,
} from 'react-router-dom';

export type RouteType<Params extends { [k in keyof Params]?: string } = Record<string, never>> = {
  router: RouteTypeObject<Params>;
}

export type RouteTypeObject<Params extends {
  [k in keyof Params]?: string
} = Record<string, never>> = {
  navigate: NavigateFunction;
  location: Location;
  params: Params;
}

function withRouter(Component: any) {
  function ComponentWithRouterProp(props: any) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return (
      <Component
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}

export default withRouter;
